import React from 'react'
import { LEFT_DOUBLE_ARROW, LEFT_ENABLE, RIGHT_ENABLE, RIGHT_DOUBLE_ARROW } from '../../../constants/icons/ArrowIcon';
import styled from '@emotion/styled';

type CaptionProps = {
  displayMonth: Date,
  navigateMonth : (action: string) => void
}
const MonthDisplayWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 4px 4px 20px 0;
`

const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`

const Arrows = styled.div`
  cursor: pointer;
`

const MonthText = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  width: 100%;
  text-align: center;
`

const Caption = (props: CaptionProps) => {
  const { displayMonth, navigateMonth  } = props;
  const date = new Date(displayMonth);
  const month = date.toLocaleString('default', { month: 'long' });
  const year = date.getFullYear();

  return (
    <MonthDisplayWrapper>
      <ArrowWrapper>
        <Arrows  onClick={() => navigateMonth('prevYear')}>
          {LEFT_DOUBLE_ARROW}
        </Arrows>
        <Arrows onClick={() => navigateMonth('prev')}>
          {LEFT_ENABLE}
        </Arrows>
      </ArrowWrapper>
      <MonthText>{month} {year}</MonthText>
      <ArrowWrapper>
        <Arrows onClick={() => navigateMonth('next')}>
          {RIGHT_ENABLE}
        </Arrows>
        <Arrows onClick={() => navigateMonth('nextYear')}>
          {RIGHT_DOUBLE_ARROW}
        </Arrows>
      </ArrowWrapper>
    </MonthDisplayWrapper>
  )
}

export default Caption;
